import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-life-at-protectt-ai',
  templateUrl: './life-at-protectt-ai.component.html',
  styleUrls: ['./life-at-protectt-ai.component.css']
})
export class LifeAtProtecttAiComponent implements OnInit {

  heading = "Our Protecttors camp their work to safeguard mobile security";
  subheading = "Protectt.ai is helping the digital world to stay safe and secured. Our energy is channelized to achieve one common goal – Protectt. Our biggest trait is innovation, We believe that’s what made who we are today. We allow our team to experiment objectively and realize their truest potential. You will be part of this energetic and enthusiastic team when your expertise meets our expectation. Go ahead and apply for the appropriate job openings we have and become a part of the Protectt family";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title,
    private metaTagService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle('Life at Protectt.ai | Artificial Intelligence and Security');
    this.metaTagService.updateTag(
      { name: 'description', content: 'Protectt.ai is helping the digital world to stay safe and secured. Our Artificial Intelligence and Security is channelized to achieve innovation.' }
    );
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
